import { render } from "./LastViewedClientsTabs.vue?vue&type=template&id=11fea632&ts=true"
import script from "./LastViewedClientsTabs.vue?vue&type=script&lang=ts"
export * from "./LastViewedClientsTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__